import PazienteAnalisiRischi from "../";

const routes = [
    { name: "AnalisiRischiList", path: "/paziente/analisirischi", component: PazienteAnalisiRischi.AnalisiRischiList, meta: { title: "riskAnalysis.lblTitle" } },
    { name: "AnalisiRischiView", path: "/paziente/analisirischi/view/:id", component: PazienteAnalisiRischi.AnalisiRischiView, meta: { title: "riskAnalysis.lblTitle" } },
    { name: "AnalisiRischiEdit", path: "/paziente/analisirischi/edit/:id", component: PazienteAnalisiRischi.AnalisiRischiEdit, meta: { title: "riskAnalysis.lblTitle" } },
];

export default routes;
